// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27black%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.case-card {
  padding: 15px;
  margin: 10px 0 20px;
  background: var(--primary-background-color);
  position: relative;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 0.375rem;
}
.case-card .card-top {
  display: flex;
  align-items: center;
}
.case-card .card-top input[type=checkbox] {
  background-color: var(--primary-color);
}
.case-card .card-top .serial-number {
  background-color: var(--primary-background-color);
  font-size: 15px;
  font-weight: 600;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.case-card .card-top .serial-no-checkboxes {
  margin-left: 10px;
}
.case-card .card-top .card-header-content {
  flex: 1 1;
  margin-left: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title .label-pill {
  background: var(--label-color);
  color: var(--text-color);
  padding: 2px 10px;
  font-size: 12px;
  border-radius: 4px;
  margin-left: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .parties-title .bubble-notification {
  background-color: crimson;
  color: white;
  font-size: 11px;
  font-weight: bold;
  border-radius: 50%;
  padding: 2px 7px;
  margin-left: 8px;
  animation: popIn 0.3s ease-in-out;
}
@keyframes popIn {
  from {
    transform: scale(0.6);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.case-card .card-top .card-header-content .files-status {
  display: flex;
  align-items: center;
}
.case-card .card-top .card-header-content .files-status .filed-on {
  font-size: 12px;
  color: #555;
  margin-right: 10px;
}
.case-card .card-top .card-header-content .files-status .status-pill {
  background: var(--status-color);
  color: var(--text-color);
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 3px;
}
.case-card .card-top .card-header-content .files-status .status-pill.disposed {
  background: var(--secondary-background-color);
}
.case-card .card-top .reappeal-btn {
  background-color: var(--success-color);
  color: white;
  border: none;
  border-radius: 50%;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  margin-left: 10px;
  transition: all 0.2s ease;
}
.case-card .card-top .reappeal-btn:active {
  transform: scale(0.95);
}
.case-card .card-top .reappeal-btn.has-data {
  background-color: var(--primary-light-color);
}
.case-card .case-meta {
  margin-top: 20px;
  margin-left: 20px;
  font-size: 13px;
  color: var(--text-color-second);
  display: flex;
  justify-content: space-between;
}
.case-card .case-meta-main .case-meta-details {
  display: flex;
  align-items: center;
}
.case-card .case-meta-main .case-meta-details p:not(:first-child) {
  margin-left: 2px;
}
.case-card .case-meta-main .case-meta-details .case-card-detail {
  color: var(--text-color-fourth);
}
.case-card .case-meta-main-assigned {
  background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);
  border: 1px solid #bae6fd;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 120px;
}
.case-card .case-meta-main-assigned .assigned-to-label, .case-card .case-meta-main-assigned .advocate-name {
  color: var(--primary-color);
}
.case-card .case-meta-mob-edit .edit-btn-assign {
  margin-left: auto;
  padding: 3px 6px;
  border: 1px solid #ccc;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
  font-size: 12px;
  color: #333;
}
.case-card .case-meta-mob-edit .edit-btn-assign:hover {
  background-color: #eee;
}
.case-card .case-meta-mob-edit .edit-btn-assign.mobile-edit {
  display: none;
  margin-top: 10px;
}
.case-card hr {
  margin: 20px 0;
}
.case-card .court-details {
  display: flex;
  justify-content: space-between;
}
.case-card .court-details .case-meta-court {
  margin-left: 20px;
  font-size: 13px;
  color: var(--text-color-second);
}
.case-card .bottom-bar {
  display: flex;
  border-radius: 6px;
}
.case-card .bottom-bar .date-box,
.case-card .bottom-bar .assigned-box {
  background: #e2e8f0;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-right: 10px;
}
.case-card .bottom-bar .reappeal-info-bottom {
  display: flex;
  gap: 10px;
  margin-right: 10px;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom {
  background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);
  border: 1px solid #bae6fd;
  padding: 10px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 120px;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p {
  margin: 0;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p:first-child {
  color: var(--primary-color);
  font-weight: 600;
}
.case-card .bottom-bar .reappeal-info-bottom .reappeal-item-bottom p:last-child {
  color: var(--primary-color);
  font-weight: 500;
}
.case-card .bottom-bar .fetched-case-assigned {
  margin-right: 0px;
}
.case-card .bottom-bar .actions-case-card {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.case-card .bottom-bar .actions-case-card .edit-btn-assign {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 50px;
  background-color: #fff;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
}
.case-card .bottom-bar .actions-case-card .edit-btn-assign:hover {
  background-color: #eee;
}
.case-card .expand-toggle-bottom {
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
.case-card .expand-toggle-bottom .circle-arrow {
  width: 20px;
  height: 20px;
  background-color: rgba(196, 196, 196, 0.7);
  color: var(--text-color-fourth);
  border-radius: 50%;
  font-size: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid white;
  transition: transform 0.3s ease;
}
.case-card .expand-toggle-bottom .circle-arrow.up {
  transform: rotate(180deg);
}
.case-card .card-details {
  transition: max-height 0.3s ease-in-out;
  border-top: 1px solid #eee;
}
.case-card .card-details .card-det-div {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  padding: 15px;
}
.case-card .card-details .card-det-div .card-section {
  flex: 1 1;
}
.case-card .card-details .card-det-div .docs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
  gap: 13px;
  width: 100%;
}
.case-card .card-details .card-det-div .case-extend-details-card {
  padding: 10px;
  border-radius: 6px;
  background-color: #e2e8f0;
  margin-top: 10px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: fadeIn 0.2s ease-out;
  padding: 20px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.reappeal-modal {
  background: white;
  border-radius: 12px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
}
.reappeal-modal .modal-header {
  padding: 24px 24px 16px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}
.reappeal-modal .modal-header h3 {
  margin: 0;
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
}
.reappeal-modal .modal-header .close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  line-height: 1;
}
.reappeal-modal .modal-header .close-btn:hover {
  background-color: #f3f4f6;
  color: #374151;
}
.reappeal-modal .modal-header .close-btn:active {
  transform: scale(0.95);
}
.reappeal-modal .modal-body {
  padding: 24px;
}
.reappeal-modal .modal-body form {
  display: flex;
  flex-direction: column;
}
.reappeal-modal .modal-body .form-group {
  margin-bottom: 24px;
}
.reappeal-modal .modal-body .form-group:last-of-type {
  margin-bottom: 32px;
}
.reappeal-modal .modal-body .form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #374151;
  font-size: 14px;
}
.reappeal-modal .modal-body .form-group input[type=number] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=number]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=number]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=number]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=number]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group input[type=number][type=number] {
  -moz-appearance: textfield;
}
.reappeal-modal .modal-body .form-group input[type=text] {
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
}
.reappeal-modal .modal-body .form-group input[type=text]:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group input[type=text]::placeholder {
  color: #9ca3af;
}
.reappeal-modal .modal-body .form-group input[type=text]::-webkit-outer-spin-button, .reappeal-modal .modal-body .form-group input[type=text]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.reappeal-modal .modal-body .form-group .date-select-container {
  display: flex;
  gap: 10px;
  width: 100%;
}
.reappeal-modal .modal-body .form-group select.date-select {
  flex: 1 1;
  padding: 12px 10px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s ease;
  background-color: white;
  color: #1f2937;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position-x: 95%;
  background-position-y: 50%;
}
.reappeal-modal .modal-body .form-group select.date-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}
.reappeal-modal .modal-body .form-group .calculated-date-display {
  margin-top: 12px;
  padding: 10px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: #374151;
}
.reappeal-modal .modal-body .form-group .calculated-date-display strong {
  color: #1d4ed8;
  font-weight: 600;
}
.reappeal-modal .modal-body .form-group .calculated-date {
  padding: 16px;
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border-radius: 8px;
  font-weight: 600;
  text-align: center;
  font-size: 16px;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
  animation: slideInDate 0.3s ease-out;
}
@keyframes slideInDate {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.reappeal-modal .modal-body .modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 0;
}
.reappeal-modal .modal-body .modal-actions button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease;
  min-width: 110px;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #dc2626;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:hover {
  background-color: #b91c1c;
}
.reappeal-modal .modal-body .modal-actions button.cancel-btn:active {
  transform: scale(0.98);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  min-width: 120px;
  transition: all 0.2s ease;
  background-color: #16a34a;
  color: white;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:hover:not(:disabled) {
  background-color: #15803d;
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:active:not(:disabled) {
  transform: translateY(0);
}
.reappeal-modal .modal-body .modal-actions button.submit-btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
  box-shadow: none;
}

@keyframes slideIn {
  from {
    transform: translateY(-30px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .case-card {
    padding: 10px;
  }
  .case-card .card-top {
    align-items: flex-start;
  }
  .case-card .card-top .reappeal-btn {
    width: 24px;
    height: 24px;
    font-size: 14px;
    margin-left: 8px;
    margin-top: 5px;
  }
  .case-card .card-top .card-header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .case-card .card-top .card-header-content .parties-title {
    font-size: 12px;
    align-items: flex-start;
  }
  .case-card .card-top .card-header-content .parties-title .label-pill {
    font-size: 11px;
  }
  .case-card .card-top .card-header-content .files-status {
    flex-direction: column;
    align-items: flex-start;
    margin-top: 10px;
  }
  .case-card .card-top .card-header-content .files-status .filed-on {
    font-size: 12px;
  }
  .case-card .card-top .card-header-content .files-status .status-pill {
    margin: 2px 0;
    font-size: 11px;
  }
  .case-card .court-details {
    justify-content: end;
  }
  .case-card .case-meta {
    justify-content: space-between;
    align-items: end;
    margin-left: 23px;
    margin-top: 10px;
  }
  .case-card .case-meta-main .case-meta-details {
    margin-left: 0 !important;
    font-size: 13px;
  }
  .case-card .case-meta-main .case-meta-details p:not(:first-child) {
    font-size: 13px;
  }
  .case-card .case-meta-main .case-meta-details .case-card-detail {
    font-size: 13px;
  }
  .case-card .case-meta-mob-edit .mobile-edit {
    display: flex !important;
    align-self: flex-end;
    margin-top: 10px;
    margin-right: 10px;
  }
  .case-card .expand-toggle-bottom,
  .case-card .card-details,
  .case-card .case-meta-court,
  .case-card hr,
  .case-card .date-box,
  .case-card .assigned-box,
  .case-card .reappeal-info-bottom,
  .case-card .bottom-bar {
    display: none !important;
  }
  .reappeal-modal {
    width: 95%;
    margin: 20px;
  }
  .reappeal-modal .modal-body .modal-actions {
    flex-direction: column;
  }
  .reappeal-modal .modal-body .modal-actions button {
    width: 100%;
    margin-bottom: 8px;
  }
  .reappeal-modal .modal-body .modal-actions button:last-child {
    margin-bottom: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CaseCard/CaseCard.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,2CAAA;EAEA,kBAAA;EACA,eAAA;EAEA,sBAAA;EACA,uBAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;AADJ;AAGI;EACE,sCAAA;AADN;AAII;EACE,iDAAA;EAEA,eAAA;EACA,gBAAA;EAEA,YAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cAAA;AANN;AASI;EACE,iBAAA;AAPN;AAUI;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AARN;AAUM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AARR;AAUQ;EACE,8BAAA;EACA,wBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AARV;AAWQ;EACE,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iCAAA;AATV;AAaQ;EACE;IACE,qBAAA;IACA,UAAA;EAXV;EAcQ;IACE,mBAAA;IACA,UAAA;EAZV;AACF;AAgBM;EACE,aAAA;EACA,mBAAA;AAdR;AAgBQ;EACE,eAAA;EACA,WAAA;EACA,kBAAA;AAdV;AAiBQ;EACE,+BAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAfV;AAiBU;EACE,6CAAA;AAfZ;AAqBI;EACE,sCAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAnBN;AAqBM;EACE,sBAAA;AAnBR;AAsBM;EACE,4CAAA;AApBR;AA0BE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,aAAA;EACA,8BAAA;AAxBJ;AA2BM;EACE,aAAA;EACA,mBAAA;AAzBR;AA4BU;EACE,gBAAA;AA1BZ;AA8BQ;EACE,+BAAA;AA5BV;AAqCI;EACE,6DAAA;EACF,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAnCJ;AAqCI;EACE,2BAAA;AAnCN;AAyCM;EACE,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAvCR;AAyCQ;EACE,sBAAA;AAvCV;AA0CQ;EACE,aAAA;EACA,gBAAA;AAxCV;AA8CE;EACE,cAAA;AA5CJ;AA+CE;EACE,aAAA;EAEA,8BAAA;AA9CJ;AAgDI;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;AA9CN;AAsDE;EACE,aAAA;EAEA,kBAAA;AArDJ;AAwDI;;EAEE,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;AAtDN;AA+DI;EACE,aAAA;EACA,SAAA;EACA,kBAAA;AA7DN;AA+DM;EACE,6DAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AA7DR;AA+DQ;EACE,SAAA;AA7DV;AA+DU;EACE,2BAAA;EACA,gBAAA;AA7DZ;AAgEU;EACE,2BAAA;EACA,gBAAA;AA9DZ;AAoEI;EACE,iBAAA;AAlEN;AAqEI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAnEN;AAoEM;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAnER;AAqEQ;EACE,sBAAA;AAnEV;AAyEE;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;AAvEJ;AAyEI;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AAvEN;AAyEM;EACE,yBAAA;AAvER;AA4EE;EACE,uCAAA;EACA,0BAAA;AA1EJ;AA4EI;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EAEA,eAAA;EACA,aAAA;AA3EN;AA6EM;EACE,SAAA;AA3ER;AA+EM;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;AA7ER;AAgFM;EACE,aAAA;EAEA,kBAAA;EACA,yBAAA;EACA,gBAAA;AA/ER;;AAmGA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,+BAAA;EACA,aAAA;AAhGF;;AAmGA;EACE;IACE,UAAA;EAhGF;EAkGA;IACE,UAAA;EAhGF;AACF;AAmGA;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,2CAAA;EACA,gCAAA;EACA,gBAAA;AAjGF;AAmGE;EACE,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;AAjGJ;AAmGI;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAjGN;AAoGI;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;AAlGN;AAoGM;EACE,yBAAA;EACA,cAAA;AAlGR;AAqGM;EACE,sBAAA;AAnGR;AAwGE;EACE,aAAA;AAtGJ;AAwGI;EACE,aAAA;EACA,sBAAA;AAtGN;AAyGI;EACE,mBAAA;AAvGN;AAyGM;EACE,mBAAA;AAvGR;AA0GM;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAxGR;AA4GM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AA1GR;AA4GQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA1GV;AA6GQ;EACE,cAAA;AA3GV;AA8GQ;EAEE,wBAAA;EACA,SAAA;AA7GV;AAgHQ;EACE,0BAAA;AA9GV;AAiHM;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AA/GR;AAiHQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA/GV;AAkHQ;EACE,cAAA;AAhHV;AAmHQ;EAEE,wBAAA;EACA,SAAA;AAlHV;AAyHM;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAvHR;AA0HM;EACE,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,yDAAA;EACA,4BAAA;EACA,0BAAA;EACA,0BAAA;AAxHR;AA0HQ;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAxHV;AA4HM;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA1HR;AA4HQ;EACE,cAAA;EACA,gBAAA;AA1HV;AA8HM;EACE,aAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,8CAAA;EACA,oCAAA;AA5HR;AA+HM;EACE;IACE,UAAA;IACA,4BAAA;EA7HR;EA+HM;IACE,UAAA;IACA,wBAAA;EA7HR;AACF;AAiII;EACE,aAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;AA/HN;AAiIM;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;AA/HR;AAiIQ;EAIE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAlIV;AAoIU;EACE,yBAAA;AAlIZ;AAsIU;EACE,sBAAA;AApIZ;AAwIQ;EAIE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;AAzIV;AAgJU;EACE,yBAAA;AA9IZ;AAiJU;EACE,wBAAA;AA/IZ;AAkJU;EACE,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAhJZ;;AAwJA;EACE;IACE,wCAAA;IACA,UAAA;EArJF;EAuJA;IACE,iCAAA;IACA,UAAA;EArJF;AACF;AAwJA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAtJF;;AAyJA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;AAtJF;;AAyJA;EACE;IACE,uBAAA;EAtJF;EAyJA;IACE,yBAAA;EAvJF;AACF;AA0JA;EACE;IACE,aAAA;EAxJF;EA0JE;IAEE,uBAAA;EAzJJ;EA2JI;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;EAzJN;EA4JI;IACE,sBAAA;IACA,uBAAA;EA1JN;EA4JM;IACE,eAAA;IACA,uBAAA;EA1JR;EA4JQ;IACE,eAAA;EA1JV;EA8JM;IACE,sBAAA;IACA,uBAAA;IACA,gBAAA;EA5JR;EA8JQ;IACE,eAAA;EA5JV;EA+JQ;IACE,aAAA;IACA,eAAA;EA7JV;EAmKE;IACE,oBAAA;EAjKJ;EAoKE;IACE,8BAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EAlKJ;EAqKM;IACE,yBAAA;IACA,eAAA;EAnKR;EAsKU;IACE,eAAA;EApKZ;EAwKQ;IACE,eAAA;EAtKV;EA4KM;IACE,wBAAA;IACA,oBAAA;IACA,gBAAA;IACA,kBAAA;EA1KR;EA+KE;;;;;;;;IAQE,wBAAA;EA7KJ;EAkLA;IACE,UAAA;IACA,YAAA;EAhLF;EAmLI;IACE,sBAAA;EAjLN;EAmLM;IACE,WAAA;IACA,kBAAA;EAjLR;EAmLQ;IACE,gBAAA;EAjLV;AACF","sourcesContent":[".case-card {\n  padding: 15px;\n  margin: 10px 0 20px;\n  background: var(--primary-background-color);\n  // font-family: sans-serif;\n  position: relative;\n  cursor: pointer;\n  // box-shadow: 0 1px 3px var(--boxshadow-color);\n  border: 1px solid #ddd;\n  border-radius: 0.375rem;\n\n  .card-top {\n    display: flex;\n    align-items: center;\n\n    input[type=\"checkbox\"] {\n      background-color: var(--primary-color);\n    }\n\n    .serial-number {\n      background-color: var(--primary-background-color);\n      //color: white;\n      font-size: 15px;\n      font-weight: 600;\n      //width: 24px;\n      height: 24px;\n      //border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      //margin-right: 10px;\n      flex-shrink: 0;\n    }\n\n    .serial-no-checkboxes{\n      margin-left: 10px;\n    }\n\n    .card-header-content {\n      flex: 1;\n      margin-left: 7px;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      .parties-title {\n        font-size: 14px;\n        font-weight: 600;\n        display: flex;\n        align-items: center;\n\n        .label-pill {\n          background: var(--label-color);\n          color: var(--text-color);\n          padding: 2px 10px;\n          font-size: 12px;\n          border-radius: 4px;\n          margin-left: 10px;\n          justify-content: center;\n          display: flex;\n          align-items: center;\n        }\n\n        .bubble-notification {\n          background-color: crimson;\n          color: white;\n          font-size: 11px;\n          font-weight: bold;\n          border-radius: 50%;\n          padding: 2px 7px;\n          margin-left: 8px;\n          animation: popIn 0.3s ease-in-out;\n          // box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);\n        }\n\n        @keyframes popIn {\n          from {\n            transform: scale(0.6);\n            opacity: 0;\n          }\n\n          to {\n            transform: scale(1);\n            opacity: 1;\n          }\n        }\n      }\n\n      .files-status {\n        display: flex;\n        align-items: center;\n\n        .filed-on {\n          font-size: 12px;\n          color: #555;\n          margin-right: 10px;\n        }\n\n        .status-pill {\n          background: var(--status-color);\n          color: var(--text-color);\n          font-size: 12px;\n          padding: 3px 6px;\n          border-radius: 3px;\n\n          &.disposed {\n            background: var(--secondary-background-color);\n          }\n        }\n      }\n    }\n\n    .reappeal-btn {\n      background-color: var(--success-color);\n      color: white;\n      border: none;\n      border-radius: 50%;\n      width: 28px;\n      height: 28px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      font-size: 16px;\n      margin-left: 10px;\n      transition: all 0.2s ease;\n\n      &:active {\n        transform: scale(0.95);\n      }\n\n      &.has-data {\n        background-color: var(--primary-light-color);\n\n      }\n    }\n  }\n\n  .case-meta {\n    margin-top: 20px;\n    margin-left: 20px;\n    font-size: 13px;\n    color: var(--text-color-second);\n    display: flex;\n    justify-content: space-between;\n\n    &-main {\n      .case-meta-details {\n        display: flex;\n        align-items: center;\n\n        p {\n          &:not(:first-child) {\n            margin-left: 2px;\n          }\n        }\n\n        .case-card-detail {\n          color: var(--text-color-fourth);\n        }\n\n        // &:not(:first-child) {\n        //   margin-left: 10px;\n        // }\n      }\n    }\n\n    &-main-assigned{\n      background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);\n    border: 1px solid #bae6fd;\n    padding: 10px;\n    border-radius: 4px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-width: 120px;\n\n    .assigned-to-label , .advocate-name{\n      color: var(--primary-color);\n    }\n\n    }\n\n    &-mob-edit {\n      .edit-btn-assign {\n        margin-left: auto;\n        padding: 3px 6px;\n        border: 1px solid #ccc;\n        border-radius: 50px;\n        background-color: #fff;\n        cursor: pointer;\n        font-size: 12px;\n        color: #333;\n\n        &:hover {\n          background-color: #eee;\n        }\n\n        &.mobile-edit {\n          display: none;\n          margin-top: 10px;\n        }\n      }\n    }\n  }\n\n  hr {\n    margin: 20px 0;\n  }\n\n  .court-details {\n    display: flex;\n    // margin-bottom: 20px;\n    justify-content: space-between;\n\n    .case-meta-court {\n      margin-left: 20px;\n      font-size: 13px;\n      color: var(--text-color-second);\n\n      // .courtnames {\n      //   font-size: medium;\n      // }\n    }\n  }\n\n  .bottom-bar {\n    display: flex;\n    // padding: 10px;\n    border-radius: 6px;\n    // align-items: center;\n\n    .date-box,\n    .assigned-box {\n      background: #e2e8f0;\n      padding: 10px;\n      border-radius: 4px;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      margin-right: 10px;\n\n      // p {\n      //   margin-block-start: 0.5em !important;\n      //   margin-block-end: 0.5em !important;\n      // }\n    }\n\n    // Re-Appeal Info Display in Bottom Bar\n    .reappeal-info-bottom {\n      display: flex;\n      gap: 10px;\n      margin-right: 10px;\n\n      .reappeal-item-bottom {\n        background: linear-gradient(135deg, #f0f9ff 0%, #eef2ff 100%);\n        border: 1px solid #bae6fd;\n        padding: 10px;\n        border-radius: 4px;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        min-width: 120px;\n\n        p {\n          margin: 0;\n\n          &:first-child {\n            color: var(--primary-color);\n            font-weight: 600;\n          }\n\n          &:last-child {\n            color: var(--primary-color);\n            font-weight: 500;\n          }\n        }\n      }\n    }\n\n    .fetched-case-assigned {\n      margin-right: 0px;\n    }\n\n    .actions-case-card {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      .edit-btn-assign {\n        // margin-left: auto;\n        padding: 10px;\n        border: 1px solid #ccc;\n        border-radius: 50px;\n        background-color: #fff;\n        cursor: pointer;\n        font-size: 16px;\n        color: #333;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        &:hover {\n          background-color: #eee;\n        }\n      }\n    }\n  }\n\n  .expand-toggle-bottom {\n    position: absolute;\n    bottom: -10px;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 2;\n\n    .circle-arrow {\n      width: 20px;\n      height: 20px;\n      background-color: rgba(196, 196, 196, 0.7);\n      color: var(--text-color-fourth);\n      border-radius: 50%;\n      font-size: 14px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      border: 2px solid white;\n      transition: transform 0.3s ease;\n\n      &.up {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .card-details {\n    transition: max-height 0.3s ease-in-out;\n    border-top: 1px solid #eee;\n\n    .card-det-div {\n      display: flex;\n      justify-content: space-between;\n      gap: 20px;\n      // width: 100%;\n      flex-wrap: wrap;\n      padding: 15px;\n\n      .card-section {\n        flex: 1;\n        // min-width: 250px;\n      }\n\n      .docs-grid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));\n        gap: 13px;\n        width: 100%;\n      }\n\n      .case-extend-details-card {\n        padding: 10px;\n        // border: px solid #000;\n        border-radius: 6px;\n        background-color: #e2e8f0;\n        margin-top: 10px;\n        // width: 80%;\n      }\n    }\n  }\n}\n// .card-header-content {\n//   transition: margin-left 0.2s ease;\n// }\n\n// .case-card .card-top input[type=\"checkbox\"] {\n//   animation: fadeIn 0.2s ease-in;\n// }\n\n// @keyframes fadeIn {\n//   from { opacity: 0; transform: scale(0.8); }\n//   to { opacity: 1; transform: scale(1); }\n// }\n\n// Re-Appeal Modal Styles\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: fadeIn 0.2s ease-out;\n  padding: 20px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.reappeal-modal {\n  background: white;\n  border-radius: 12px;\n  width: 100%;\n  max-width: 480px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\n  animation: slideIn 0.3s ease-out;\n  overflow: hidden;\n\n  .modal-header {\n    padding: 24px 24px 16px 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #e5e7eb;\n\n    h3 {\n      margin: 0;\n      color: #1f2937;\n      font-size: 20px;\n      font-weight: 600;\n    }\n\n    .close-btn {\n      background: none;\n      border: none;\n      font-size: 28px;\n      cursor: pointer;\n      color: #6b7280;\n      padding: 0;\n      width: 32px;\n      height: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      transition: all 0.2s ease;\n      line-height: 1;\n\n      &:hover {\n        background-color: #f3f4f6;\n        color: #374151;\n      }\n\n      &:active {\n        transform: scale(0.95);\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 24px;\n\n    form {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .form-group {\n      margin-bottom: 24px;\n\n      &:last-of-type {\n        margin-bottom: 32px;\n      }\n\n      label {\n        display: block;\n        margin-bottom: 8px;\n        font-weight: 600;\n        color: #374151;\n        font-size: 14px;\n      }\n      \n\n      input[type=\"number\"] {\n        width: 100%;\n        padding: 12px 16px;\n        border: 2px solid #d1d5db;\n        border-radius: 8px;\n        font-size: 16px;\n        transition: all 0.2s ease;\n        background-color: white;\n        color: #1f2937;\n        box-sizing: border-box;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n\n        &[type=\"number\"] {\n          -moz-appearance: textfield;\n        }\n      }\n      input[type=\"text\"] {\n        width: 100%;\n        padding: 12px 16px;\n        border: 2px solid #d1d5db;\n        border-radius: 8px;\n        font-size: 16px;\n        transition: all 0.2s ease;\n        background-color: white;\n        color: #1f2937;\n        box-sizing: border-box;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n\n        &::placeholder {\n          color: #9ca3af;\n        }\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n          -webkit-appearance: none;\n          margin: 0;\n        }\n\n        \n      }\n      \n      // --- New Styles for Date Selectors ---\n      .date-select-container {\n        display: flex;\n        gap: 10px;\n        width: 100%;\n      }\n\n      select.date-select {\n        flex: 1;\n        padding: 12px 10px;\n        border: 2px solid #d1d5db;\n        border-radius: 8px;\n        font-size: 14px;\n        transition: all 0.2s ease;\n        background-color: white;\n        color: #1f2937;\n        box-sizing: border-box;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        background-image: url(\"data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n        background-repeat: no-repeat;\n        background-position-x: 95%;\n        background-position-y: 50%;\n\n        &:focus {\n          outline: none;\n          border-color: #3b82f6;\n          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n        }\n      }\n\n      .calculated-date-display {\n        margin-top: 12px;\n        padding: 10px;\n        background-color: #f3f4f6;\n        border: 1px solid #e5e7eb;\n        border-radius: 6px;\n        text-align: center;\n        font-size: 14px;\n        color: #374151;\n\n        strong {\n          color: #1d4ed8;\n          font-weight: 600;\n        }\n      }\n\n      .calculated-date {\n        padding: 16px;\n        background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n        color: white;\n        border-radius: 8px;\n        font-weight: 600;\n        text-align: center;\n        font-size: 16px;\n        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n        animation: slideInDate 0.3s ease-out;\n      }\n\n      @keyframes slideInDate {\n        from {\n          opacity: 0;\n          transform: translateY(-10px);\n        }\n        to {\n          opacity: 1;\n          transform: translateY(0);\n        }\n      }\n    }\n\n    .modal-actions {\n      display: flex;\n      gap: 12px;\n      justify-content: flex-end;\n      margin-top: 0;\n\n      button {\n        padding: 12px 24px;\n        border: none;\n        border-radius: 8px;\n        cursor: pointer;\n        font-size: 14px;\n        font-weight: 600;\n        transition: all 0.2s ease;\n        min-width: 110px;\n\n        &.cancel-btn {\n          // background-color: #f9fafb;\n          // color: #6b7280;\n          // border: 2px solid #e5e7eb;\n          padding: 0.75rem 1.5rem;\n          border: none;\n          border-radius: 0.375rem;\n          font-size: 0.875rem;\n          font-weight: 500;\n          cursor: pointer;\n          min-width: 120px;\n          transition: all 0.2s ease;\n          background-color: #dc2626;\n          color: white;\n\n          &:hover {\n            background-color: #b91c1c;\n            //border-color: #d1d5db;\n          }\n\n          &:active {\n            transform: scale(0.98);\n          }\n        }\n\n        &.submit-btn {\n          // background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n          // color: white;\n          // box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n          padding: 0.75rem 1.5rem;\n          border: none;\n          border-radius: 0.375rem;\n          font-size: 0.875rem;\n          font-weight: 500;\n          cursor: pointer;\n          min-width: 120px;\n          transition: all 0.2s ease;\n          background-color: #16a34a;\n          color: white;\n\n          // &:hover:not(:disabled) {\n          //   //transform: translateY(-1px);\n          //   box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4);\n          // }\n\n          &:hover:not(:disabled) {\n            background-color: #15803d;\n          }\n\n          &:active:not(:disabled) {\n            transform: translateY(0);\n          }\n\n          &:disabled {\n            background: #d1d5db;\n            cursor: not-allowed;\n            opacity: 0.6;\n            transform: none;\n            box-shadow: none;\n          }\n        }\n      }\n    }\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(-30px) scale(0.95);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0) scale(1);\n    opacity: 1;\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  width: 30px;\n  height: 30px;\n  animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 768px) {\n  .case-card {\n    padding: 10px;\n\n    .card-top {\n      // flex-direction: column;\n      align-items: flex-start;\n\n      .reappeal-btn {\n        width: 24px;\n        height: 24px;\n        font-size: 14px;\n        margin-left: 8px;\n        margin-top: 5px;\n      }\n\n      .card-header-content {\n        flex-direction: column;\n        align-items: flex-start;\n\n        .parties-title {\n          font-size: 12px;\n          align-items: flex-start;\n\n          .label-pill {\n            font-size: 11px;\n          }\n        }\n\n        .files-status {\n          flex-direction: column;\n          align-items: flex-start;\n          margin-top: 10px;\n\n          .filed-on {\n            font-size: 12px;\n          }\n\n          .status-pill {\n            margin: 2px 0;\n            font-size: 11px;\n          }\n        }\n      }\n    }\n\n    .court-details {\n      justify-content: end;\n    }\n\n    .case-meta {\n      justify-content: space-between;\n      align-items: end;\n      margin-left: 23px;\n      margin-top: 10px;\n\n      &-main {\n        .case-meta-details {\n          margin-left: 0 !important;\n          font-size: 13px;\n\n          p {\n            &:not(:first-child) {\n              font-size: 13px;\n            }\n          }\n\n          .case-card-detail {\n            font-size: 13px;\n          }\n        }\n      }\n\n      &-mob-edit {\n        .mobile-edit {\n          display: flex !important;\n          align-self: flex-end;\n          margin-top: 10px;\n          margin-right: 10px;\n        }\n      }\n    }\n\n    .expand-toggle-bottom,\n    .card-details,\n    .case-meta-court,\n    hr,\n    .date-box,\n    .assigned-box,\n    .reappeal-info-bottom,\n    .bottom-bar {\n      display: none !important;\n    }\n  }\n\n  // Mobile modal adjustments\n  .reappeal-modal {\n    width: 95%;\n    margin: 20px;\n\n    .modal-body {\n      .modal-actions {\n        flex-direction: column;\n\n        button {\n          width: 100%;\n          margin-bottom: 8px;\n\n          &:last-child {\n            margin-bottom: 0;\n          }\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
